import initialState from './initialState'
import {
  STORE_BARS_TARE,
  STORE_BARS_AVERAGES,
  STORE_BARS_MULTS,
  STORE_BAR_MULT,
  RESET_BAR_RECORD,
  RESET_BAR_RECORDS,
  RESET_BAR_STRIKE_ICONS,
  RESET_LEARNED_AVERAGES,
  CREATE_BAR_RECORD,
  SET_BAR_RECORD,
  LEARN_MODE_BAR_STRIKE_STATUS,
  CALCULATE_BAR_AVERAGE
} from '../actions/actionTypes'

export default function learnModeReducer(state = initialState.learnMode, action) {
  switch (action.type) {
    case STORE_BARS_TARE :
      return {
        ...state,
        tares: action.tares
      }

    case STORE_BARS_AVERAGES : {
      const stateKey = action.mode === 'high' ? 'averageHighs' : 'averageLows'

      return {
        ...state,
        [stateKey]: action.averages
      }
    }

    case STORE_BAR_MULT : {
      const stateKey = action.mode + 'Mults'
      return {
        ...state,
        [stateKey]: state[stateKey].map((a,i) => {
          if(action.barIndex === i) {
            return Math.round(action.mult * 128)
          } else {
            return a
          }
        })
      }
    }

    case STORE_BARS_MULTS : {
      const stateKey = action.mode + 'Mults'
      return {
        ...state,
        [stateKey]: action.mults
      }
    }

    case CREATE_BAR_RECORD :
      return {
        ...state,
        records: state.records.map((r,i) => {
          if(i === action.barIndex) {
            return {
              'soft': [],
              'hard': []
            }
          } else {
            return r
          }
        })
      }

    case RESET_BAR_RECORD :
      return {
        ...state,
        records: state.records.slice(0, action.barIndex)
          .concat({
            ...state.records[action.barIndex],
            [action.strikeType]: []
          })
          .concat(state.records.slice(action.barIndex + 1))
      }

    case RESET_BAR_RECORDS :
      return {
        ...state,
        records: Array.from(Array(43))
      }

    case RESET_BAR_STRIKE_ICONS :
      return {
        ...state,
        completedStrikes: Array.from(Array(43)).fill(0)
      }

    case RESET_LEARNED_AVERAGES : {
      const stateKey = action.mode === 'high' ? 'learnedAverageHighs' : 'learnedAverageLows'

      return {
        ...state,
        [stateKey]: Array.from(Array(43)).fill(null)
      }
    }

    case SET_BAR_RECORD :
      return {
        ...state,
        records: state.records.slice(0, action.barIndex)
          .concat({
            ...state.records[action.barIndex],
            [action.strikeType]: state.records[action.barIndex][action.strikeType].concat(action.rawVelocity)
          })
          .concat(state.records.slice(action.barIndex + 1))
      }

    case LEARN_MODE_BAR_STRIKE_STATUS :
      return {
        ...state,
        completedStrikes: state.completedStrikes.map((s,i) => {
          if(action.barIndex === i) {
            return action.strikeTypeNum + s
          } else {
            return s
          }
        })
      }

    case CALCULATE_BAR_AVERAGE : {
      const stateKey = action.mode === 'high' ? 'learnedAverageHighs' : 'learnedAverageLows'

      return {
        ...state,
        [stateKey]: state[stateKey].map((g,i) => {
          if(action.barIndex === i) {
            return action.average.toFixed(2)
          } else {
            return g
          }
        })
      }
    }

    default:
      return state
  }
}
